import { FC, useEffect } from "react";
import { observer } from "mobx-react";

import Row from "../../../ui/core/Row";
import { useObservabilityStore } from "../../../../hooks/useObservabilityStore";
import { PERMISSIONS } from "../../../../types/auth";
import { useHasPermission } from "../../../../contexts/permissions/useHasPermission";
import ObservabilityDateIntervalSelect from "./ObservabilityDateIntervalSelect";

const ObservabilityFilters: FC = observer(() => {
  const hasBillingPermission = useHasPermission(PERMISSIONS.billing);
  const {
    mainFilters,
    applyObservabilityDateInterval,
    applyObservabilityCustomDateRange,
    loadUsageMetrics,
    loadBillingMetrics,
    clearState,
  } = useObservabilityStore();

  const reloadMetrics = () => {
    loadUsageMetrics(hasBillingPermission);
    if (hasBillingPermission) {
      loadBillingMetrics();
    }
  };

  const handlePresetChange = (dateInterval: string) => {
    applyObservabilityDateInterval(dateInterval);
    reloadMetrics();
  };

  const handleCustomRangeApply = (from: string, to: string) => {
    applyObservabilityCustomDateRange(from, to);
    reloadMetrics();
  };

  useEffect(() => {
    return () => {
      clearState();
    };
  }, []);

  return (
    <Row sx={{ gap: 1, alignItems: "center", height: "auto", flexWrap: "nowrap" }}>
      <ObservabilityDateIntervalSelect
        dateInterval={mainFilters.dateInterval}
        customDateFrom={mainFilters.customDateFrom}
        customDateTo={mainFilters.customDateTo}
        onPresetChange={handlePresetChange}
        onCustomRangeApply={handleCustomRangeApply}
      />
    </Row>
  );
});

export default ObservabilityFilters;
